/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
import { UserInfoWithRole } from './UserInfoWithRole';
const CourseBulkEnrollResultParser = 
/* #__PURE__ */ parsers.object([
    ['enrolledUsers', /* #__PURE__ */ codecArray(User), 'enrolled_users'],
    [
        'ssoIncompatibleUsers',
        /* #__PURE__ */ codecArray(UserInfoWithRole),
        'sso_incompatible_users',
    ],
]);
export class CourseBulkEnrollResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseBulkEnrollResultParser.decode(input).map(res => new CourseBulkEnrollResult(res));
    }
    static unsafeDecode(input) {
        return CourseBulkEnrollResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseBulkEnrollResultParser.encode(data);
    }
    static schema() {
        return CourseBulkEnrollResultParser.schema();
    }
}
